import * as tslib_1 from "tslib";
import { Component, Prop, Watch, Model, } from "vue-property-decorator";
import { RelevanceFormControl } from "@cloudpivot/form/src/common/controls/relevance-form-control";
import SearchPanel from "./search-panel.vue";
import { H3Checkbox, H3Avatar } from "h3-mobile-vue";
// import * as list from '@cloudpivot/list'
let RelevanceFormModal = class RelevanceFormModal extends RelevanceFormControl {
    // import * as list from '@cloudpivot/list'
    constructor() {
        super(...arguments);
        this.queryConditions = [];
        this.queryColumns = [];
        this.queryActions = [];
    }
    onVisibleChange() {
        if (this.visible) {
            this.getListQueryConditions(true).then((res) => {
                if (res) {
                    this.queryConditions = res.conditions;
                    this.queryColumns = res.queryColumns;
                    this.queryActions = res.queryActions;
                }
                else {
                    this.queryConditions = [];
                }
            });
            const searchPanel = this.$refs.searchPanel;
            if (searchPanel) {
                searchPanel.reFetch();
            }
        }
    }
    isSelected(item) {
        if (!this.value || !item) {
            return false;
        }
        return this.value.id === item.id;
    }
    back() {
        this.$emit("back");
    }
    getCreater(item) {
        if (Array.isArray(item.creater)) {
            if (item.creater.length > 0) {
                return item.creater[0];
            }
        }
        return {};
    }
    change(item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            item = yield this.convertForMappings(item.data);
            this.$emit("change", item);
        });
    }
    superFetch(page, pageSize, value, formState) {
        let query = [];
        if (formState) {
            query = [formState];
        }
        else {
            query = this.queryFormData;
        }
        return this.fetch(page, pageSize, value, query, true);
    }
    getStatus(status) {
        const txt = this.$t(`cloudpivot.form.renderer.formStatus.${status.toLowerCase()}`);
        return txt;
        // switch (status) {
        //   case "DRAFT":
        //     return "草稿";
        //   case "PROCESSING":
        //     return "进行中";
        //   case "COMPLETED":
        //     return "已完成";
        //   case "CANCELED":
        //     return "已作废";
        //   default:
        //     return "";
        // }
    }
    showFilterPanel(show) {
        //   if(show){
        //     this.getListQueryConditions().then(res => {
        //       this.queryConditions = res || [];
        //     });
        //   }
    }
    onFilter(query) {
        // this.queryFormData = query.map(x => ({
        //   code : x.propertyCode,
        //   type : x.propertyType,
        //   value : x.propertyValue
        // }));
        this.queryFormData = query;
        const searchPanel = this.$refs.searchPanel;
        if (searchPanel) {
            searchPanel.reFetch();
        }
    }
    openRelevanced() {
        let returnPath = `/form/detail?schemaCode=${this.$route.query.schemaCode}&return=/apps/apps-form-list/${this.$route.query.schemaCode}`;
        returnPath = encodeURI(returnPath);
        this.$router.push({
            name: "form-detail",
            query: {
                schemaCode: this.control.options.schemaCode,
                return: returnPath,
            },
        });
    }
    get canAdd() {
        let addFlag = this.queryActions.some(v => v.actionCode == "add");
        return addFlag;
    }
    beforeCreate() {
        this
            .$options.components.FormStatus = RelevanceFormControl.loadFormStatus();
        this
            .$options.components.QueryForm = RelevanceFormControl.loadQueryForm();
        this
            .$options.components.FormItem = RelevanceFormControl.loadFormItem();
    }
};
tslib_1.__decorate([
    Prop({
        default: false,
    })
], RelevanceFormModal.prototype, "visible", void 0);
tslib_1.__decorate([
    Model("change")
], RelevanceFormModal.prototype, "value", void 0);
tslib_1.__decorate([
    Watch("visible")
], RelevanceFormModal.prototype, "onVisibleChange", null);
RelevanceFormModal = tslib_1.__decorate([
    Component({
        name: "relevance-form-modal",
        components: {
            SearchPanel,
            H3CheckboxItem: H3Checkbox.Item,
            H3Avatar,
        },
        directives: {
        // TransferDom
        },
    })
], RelevanceFormModal);
export default RelevanceFormModal;
